import Vue from 'vue'
import Router from 'vue-router'
import store from '../base/store'

const _import = pagePath => () => import(`../view/${pagePath}`)
Vue.use(Router)

function path(path) {
  // return path+".html";
  return path;
}

const router = new Router({
  //mode: 'history',
  //base: '/1231312/',
  routes: [
    // 登录
    {
      path: '/admin',
      name: 'admin',
      component: _import('admin'),
      meta: {
        'title': '登录'
      },
      beforeEnter: (to, from, next) => {
        if (sessionStorage.getItem('verifyData_userid') > 0) {
          return next(path('/main/index'))
        }
        next()
      }
    },
    // 后台
    {
      path: '/main',
      component: _import('main'),
      children: [
        {
          path: path('index'),
          name: 'index',
          component: _import('index'),
          meta: {
          },
          beforeEnter: (to, from, next) => {
            store.commit('changeMenu', 'index')
            store.commit('changeCategoryId', 0)
            next()
          },
        },
        {
          path: path('set'),
          name: 'set',
          component: _import('system/set'),
          meta: {
            'title': '基本设置'
          },
          beforeEnter: (to, from, next) => {
            store.commit('changeMenu', 'set')
            store.commit('changeCategoryId', 0)
            next()
          },
        },
        {
          path: 'system',
          name: 'system',
          component: _import('system/home'),
          children: [
            {
              path: path('companyUser'),
              name: 'user',
              component: _import('system/companyUser'),
              meta: {
                'title': '用户列表'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'user')
                next()
              },
            },
            {
              path: path('companyJigou'),
              name: 'companyJigou',
              component: _import('system/companyJigou'),
              meta: {
                'title': '组织机构'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'companyJigou')
                next()
              },
            },
            {
              path: path('department'),
              name: 'department',
              component: _import('system/department'),
              meta: {
                'title': '部门列表'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'department')
                next()
              },
            },
            {
              path: path('companyRole'),
              name: 'companyRole',
              component: _import('system/companyRole'),
              meta: {
                'title': '角色列表'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'companyRole')
                next()
              },
            },
            {
              path: path('companyRoleNav'),
              name: 'companyRoleNav',
              component: _import('system/companyRoleNav'),
              meta: {
                'title': '角色列表'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'companyRoleNav')
                next()
              },
            },
            {
              path: path('supplierList'),
              name: 'supplierList',
              component: _import('system/supplierList'),
              meta: {
                'title': '供应商管理'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'supplierList')
                next()
              },
            },
            {
              path: path('customerList'),
              name: 'customerList',
              component: _import('system/customerList'),
              meta: {
                'title': '客户信息'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'customerList')
                next()
              },
            },
            {
              path: path('clientManagement'),
              name: 'clientManagement',
              component: _import('system/clientManagement'),
              meta: {
                'title': '客户管理'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'clientManagement')
                next()
              },
            },
            {
              path: path('cailiaoList'),
              name: 'cailiaoList',
              component: _import('system/cailiaoList'),
              meta: {
                'title': '材料库'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'cailiaoList')
                next()
              },
            },
            {
              path: path('contractList'),
              name: 'contractList',
              component: _import('system/contractList'),
              meta: {
                'title': '合同备案管理'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'contractList')
                next()
              },
            },
            {
              path: path('billsList'),
              name: 'billsList',
              component: _import('system/billsList'),
              meta: {
                'title': '票据列表'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'billsList')
                next()
              },
            },
            {
              path: path('inventoryList'),
              name: 'inventoryList',
              component: _import('system/inventoryList'),
              meta: {
                'title': '进销存列表'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'inventoryList')
                next()
              },
            },
            {
              path: path('JxcInventoryList'),
              name: 'JxcInventoryList',
              component: _import('system/JxcInventoryList'),
              meta: {
                'title': '进销存'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'JxcInventoryList')
                next()
              },
            },
            {
              path: path('inventoryListNew'),
              name: 'inventoryListNew',
              component: _import('system/inventoryListNew'),
              meta: {
                'title': '新进销存列表'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'inventoryListNew')
                next()
              },
            },
            {
              path: path('projectList'),
              name: 'projectList',
              component: _import('system/projectList'),
              meta: {
                'title': '项目列表'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'projectList')
                next()
              },
            },
            {
              path: path('projectListNew'),
              name: 'projectListNew',
              component: _import('system/projectListNew'),
              meta: {
                'title': '项目列表'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'projectListNew')
                next()
              },
            },
            {
              path: path('workReportList'),
              name: 'workReportList',
              component: _import('system/workReportList'),
              meta: {
                'title': '工作汇报'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'workReportList')
                next()
              },
            },
            {
              path: path('workReportListNew'),
              name: 'workReportListNew',
              component: _import('system/workReportListNew'),
              meta: {
                'title': '工作汇报'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'workReportListNew')
                next()
              },
            },
            {
              path: path('clearingList'),
              name: 'clearingList',
              component: _import('system/clearingList'),
              meta: {
                'title': '结算管理'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'clearingList')
                next()
              },
            },
            {
              path: path('productsList'),
              name: 'productsList',
              component: _import('system/relevantSet/productsList'),
              meta: {
                'title': '产品列表'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'productsList')
                next()
              },
            },
            {
              path: path('brandList'),
              name: 'brandList',
              component: _import('system/relevantSet/brandList'),
              meta: {
                'title': '品牌列表'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'brandList')
                next()
              },
            },
            {
              path: path('clientList'),
              name: 'clientList',
              component: _import('system/relevantSet/clientList'),
              meta: {
                'title': '客户分类'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'clientList')
                next()
              },
            },
            {
              path: path('stageList'),
              name: 'stageList',
              component: _import('system/relevantSet/stageList'),
              meta: {
                'title': '项目阶段列表'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'stageList')
                next()
              },
            },
            {
              path: path('bxTypeList'),
              name: 'bxTypeList',
              component: _import('system/relevantSet/bxTypeList'),
              meta: {
                'title': '报销类型'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'bxTypeList')
                next()
              },
            },
            {
              path: path('sealTypeList'),
              name: 'sealTypeList',
              component: _import('system/relevantSet/sealTypeList'),
              meta: {
                'title': '印章类型'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'sealTypeList')
                next()
              },
            },
            {
              path: path('notesList'),
              name: 'notesList',
              component: _import('system/relevantSet/notesList'),
              meta: {
                'title': '票据类型'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'notesList')
                next()
              },
            },
            {
              path: path('payTypeList'),
              name: 'payTypeList',
              component: _import('system/relevantSet/payTypeList'),
              meta: {
                'title': '支付类型'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'payTypeList')
                next()
              },
            },
            {
              path: path('xzTypeList'),
              name: 'xzTypeList',
              component: _import('system/relevantSet/xzTypeList'),
              meta: {
                'title': '行政类型'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'xzTypeList')
                next()
              },
            },
            {
              path: path('SealsFileTypeList'),
              name: 'SealsFileTypeList',
              component: _import('system/relevantSet/SealsFileTypeList'),
              meta: {
                'title': '文件类别'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'SealsFileTypeList')
                next()
              },
            },
            {
              path: path('typeList'),
              name: 'TypeSetting',
              component: _import('system/relevantSet/typeList'),
              meta: {
                'title': '类型设置'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'TypeSetting')
                next()
              },
            },
            {
              path: path('baoxiaoList'),
              name: 'baoxiaoList',
              component: _import('system/approveManage/baoxiaoList'),
              meta: {
                'title': '报销审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'baoxiaoList')
                next()
              },
            },
            {
              path: path('useSealList'),
              name: 'useSealList',
              component: _import('system/approveManage/useSealList'),
              meta: {
                'title': '用印审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'useSealList')
                next()
              },
            },
            {
              path: path('lxList'),
              name: 'lxList',
              component: _import('system/approveManage/lxList'),
              meta: {
                'title': '立项审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'lxList')
                next()
              },
            },
            {
              path: path('invoiceList'),
              name: 'invoiceList',
              component: _import('system/approveManage/invoiceList'),
              meta: {
                'title': '发票审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'invoiceList')
                next()
              },
            },
            {
              path: path('cgContractList'),
              name: 'cgContractList',
              component: _import('system/approveManage/cgContractList'),
              meta: {
                'title': '采购合同审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'cgContractList')
                next()
              },
            },
            {
              path: path('paymentList'),
              name: 'paymentList',
              component: _import('system/approveManage/paymentList'),
              meta: {
                'title': '付款审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'paymentList')
                next()
              },
            },
            {
              path: path('xzList'),
              name: 'xzList',
              component: _import('system/approveManage/xzList'),
              meta: {
                'title': '行政审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'xzList')
                next()
              },
            },
            {
              path: path('payCollection'),
              name: 'payCollection',
              component: _import('system/payCollection'),
              meta: {
                'title': '回款管理'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'payCollection')
                next()
              },
            },
            {
              path: path('shenpiList'),
              name: 'shenpiList',
              component: _import('system/shenpiList'),
              meta: {
                'title': '审批管理'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'shenpiList')
                next()
              },
            },
            {
              path: path('shenpiListNew'),
              name: 'shenpiListNew',
              component: _import('system/shenpiListNew'),
              meta: {
                'title': '审批管理'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'shenpiListNew')
                next()
              },
            },
            {
              path: path('knowledgeClass'),
              name: 'knowledgeClass',
              component: _import('system/knowledge/class'),
              meta: {
                'title': '知识库分类'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'knowledgeClass')
                next()
              },
            },
            {
              path: path('knowledgeList'),
              name: 'knowledgeList',
              component: _import('system/knowledge/list'),
              meta: {
                'title': '知识库列表'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'knowledgeList')
                next()
              },
            },
            {
              path: path('supplyGoodsList'),
              name: 'supplyGoodsList',
              component: _import('system/supplyGoodsList'),
              meta: {
                'title': '供货管理'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'supplyGoodsList')
                next()
              },
            },
            {
              path: path('checkAcceptList'),
              name: 'checkAcceptList',
              component: _import('system/checkAcceptList'),
              meta: {
                'title': '验收管理'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'checkAcceptList')
                next()
              },
            },
            {
              path: path('weeklyWorkPlan'),
              name: 'weeklyWorkPlan',
              component: _import('system/weeklyWorkPlan'),
              meta: {
                'title': '周工作计划'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'weeklyWorkPlan')
                next()
              },
            },

            {
              path: path('baoxiaoNew'),
              name: 'baoxiaoNew',
              component: _import('system/feiYongShenPi/baoxiaoNew'),
              meta: {
                'title': '报销审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'baoxiaoNew')
                next()
              },
            },
            {
              path: path('costPayList'),
              name: 'costPayList',
              component: _import('system/feiYongShenPi/costPayList'),
              meta: {
                'title': '费用支付审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'costPayList')
                next()
              },
            },
            {
              path: path('travelList'),
              name: 'travelList',
              component: _import('system/feiYongShenPi/travelList'),
              meta: {
                'title': '差旅费报销审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'travelList')
                next()
              },
            },
            {
              path: path('userZhuanZheng'),
              name: 'renShiShenPiZhuanZheng',
              component: _import('system/renShiShenPi/zhuanZheng'),
              meta: {
                'title': '员工转正审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'renShiShenPiZhuanZheng')
                next()
              },
            },
            {
              path: path('userLuYong'),
              name: 'renShiShenPiLuYong',
              component: _import('system/renShiShenPi/luYong'),
              meta: {
                'title': '员工录用审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'renShiShenPiLuYong')
                next()
              },
            },
            {
              path: path('userDiaoDong'),
              name: 'renShiShenPiDiaoDong',
              component: _import('system/renShiShenPi/diaoDong'),
              meta: {
                'title': '员工调动审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'renShiShenPiDiaoDong')
                next()
              },
            },
            {
              path: path('userLiZhi'),
              name: 'renShiShenPiLiZhi',
              component: _import('system/renShiShenPi/liZhi'),
              meta: {
                'title': '员工离职审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'renShiShenPiLiZhi')
                next()
              },
            },
            {
              path: path('userXuQian'),
              name: 'renShiShenPiXuQian',
              component: _import('system/renShiShenPi/xuQian'),
              meta: {
                'title': '员工合同续签审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'renShiShenPiXuQian')
                next()
              },
            },
            {
              path: path('userKaiTong'),
              name: 'renShiShenPiKaiTong',
              component: _import('system/renShiShenPi/kaiTong'),
              meta: {
                'title': '员工ERP账号开通审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'renShiShenPiKaiTong')
                next()
              },
            },
            {
              path: path('yongYinList'),
              name: 'xingZhengShenPiYongYinList',
              component: _import('system/xingZhengShenPi/yongYinList'),
              meta: {
                'title': '用印审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'xingZhengShenPiYongYinList')
                next()
              },
            },
            {
              path: path('yinZhangJieLiList'),
              name: 'xingZhengShenPiYinZhangJieLiList',
              component: _import('system/xingZhengShenPi/yinZhangJieLiList'),
              meta: {
                'title': '印章借离审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'xingZhengShenPiYinZhangJieLiList')
                next()
              },
            },
            {
              path: path('wenJianList1'),
              name: 'xingZhengShenPiWenJianList1',
              component: _import('system/xingZhengShenPi/wenJianList1'),
              meta: {
                'title': '文件审批（项目平台跨级审批专用）'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'xingZhengShenPiWenJianList1')
                next()
              },
            },
            {
              path: path('wenJianList2'),
              name: 'xingZhengShenPiWenJianList2',
              component: _import('system/xingZhengShenPi/wenJianList2'),
              meta: {
                'title': '文件审批（招标、定标、合同专用）'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'xingZhengShenPiWenJianList2')
                next()
              },
            },
            {
              path: path('niGaoZhiList'),
              name: 'xingZhengShenPiNiGaoZhiList',
              component: _import('system/xingZhengShenPi/niGaoZhiList'),
              meta: {
                'title': '拟稿纸审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'xingZhengShenPiNiGaoZhiList')
                next()
              },
            },
            {
              path: path('chuChaiList'),
              name: 'xingZhengShenPiChuChaiList',
              component: _import('system/xingZhengShenPi/chuChaiList'),
              meta: {
                'title': '出差审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'xingZhengShenPiChuChaiList')
                next()
              },
            },
            {
              path: path('qingXiujiaList'),
              name: 'xingZhengShenPiQingXiujiaList',
              component: _import('system/xingZhengShenPi/qingXiujiaList'),
              meta: {
                'title': '请休假审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'xingZhengShenPiQingXiujiaList')
                next()
              },
            },
            {
              path: path('xiaoJiaList'),
              name: 'xingZhengShenPiXiaoJiaList',
              component: _import('system/xingZhengShenPi/xiaoJiaList'),
              meta: {
                'title': '销假审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'xingZhengShenPiXiaoJiaList')
                next()
              },
            },
            {
              path: path('jiaBanList'),
              name: 'xingZhengShenPiJiaBanList',
              component: _import('system/xingZhengShenPi/jiaBanList'),
              meta: {
                'title': '加班审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'xingZhengShenPiJiaBanList')
                next()
              },
            },
            {
              path: path('tiaoXiuList'),
              name: 'xingZhengShenPiTiaoXiuList',
              component: _import('system/xingZhengShenPi/tiaoXiuList'),
              meta: {
                'title': '调休审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'xingZhengShenPiTiaoXiuList')
                next()
              },
            },
            {
              path: path('bgypLingYongList'),
              name: 'xingZhengShenPiBgypLingYongList',
              component: _import('system/xingZhengShenPi/bgypLingYongList'),
              meta: {
                'title': '办公用品领用审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'xingZhengShenPiBgypLingYongList')
                next()
              },
            },
            {
              path: path('sheBeiJieYongList'),
              name: 'xingZhengShenPiSheBeiJieYongList',
              component: _import('system/xingZhengShenPi/sheBeiJieYongList'),
              meta: {
                'title': '设备借用审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'xingZhengShenPiSheBeiJieYongList')
                next()
              },
            },
            {
              path: path('yongCheList'),
              name: 'xingZhengShenPiYongCheList',
              component: _import('system/xingZhengShenPi/yongCheList'),
              meta: {
                'title': '用车审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'xingZhengShenPiYongCheList')
                next()
              },
            },
            {
              path: path('byjLingQuList'),
              name: 'xingZhengShenPiByjLingQuList',
              component: _import('system/xingZhengShenPi/byjLingQuList'),
              meta: {
                'title': '备用金领取审批'
              },
              beforeEnter: (to, from, next) => {
                store.commit('changeMenu', 'xingZhengShenPiByjLingQuList')
                next()
              },
            },
          ],
        },
      ]
    },

    // h5
    {
      path: '/login',
      name: 'login',
      component: _import('login'),
      meta: {
        'title': '登录'
      },
      beforeEnter: (to, from, next) => {
        if (sessionStorage.getItem('verifyData_userid') > 0) {
          return next(path('/main/me'))
        }
        next()
      }
    },
    {
      path: '/pdf',
      name: 'pdfIndex',
      component: _import('h5/pdf'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'pdfIndex')
        next()
      },
    },

    {
      path: '/supplierIndex',
      name: 'supplierIndex',
      component: _import('h5/supplier/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'supplierIndex')
        next()
      },
    },
    {
      path: '/supplierDetail',
      name: 'supplierDetail',
      component: _import('h5/supplier/detail'),
      meta: {
        'title': '供应商详情',
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'supplierDetail')
        next()
      },
    },
    {
      path: '/customerIndex',
      name: 'customerIndex',
      component: _import('h5/customer/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'customerIndex')
        next()
      },
    },
    {
      path: '/customerDetail',
      name: 'customerDetail',
      component: _import('h5/customer/detail'),
      meta: {
        'title': '客户详情',
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'customerDetail')
        next()
      },
    },
    {
      path: '/customerAdd',
      name: 'customerAdd',
      component: _import('h5/customer/add'),
      meta: {
        'title': '新增客户',
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'customerAdd')
        next()
      },
    },
    {
      path: '/billsIndex',
      name: 'billsIndex',
      component: _import('h5/bills/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'billsIndex')
        next()
      },
    },
    {
      path: '/billsDetail',
      name: 'billsDetail',
      component: _import('h5/bills/detail'),
      meta: {
        'title': '票据详情',
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'billsDetail')
        next()
      },
    },
    {
      path: '/billstAdd',
      name: 'billstAdd',
      component: _import('h5/bills/add'),
      meta: {
        'title': '新增票据',
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'billstAdd')
        next()
      },
    },

    {
      path: '/contractIndex',
      name: 'contractIndex',
      component: _import('h5/contract/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'contractIndex')
        next()
      },
    },
    {
      path: '/contractDetail',
      name: 'contractDetail',
      component: _import('h5/contract/detail'),
      meta: {
        'title': '合同详情',
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'customerDetail')
        next()
      },
    },
    {
      path: '/contractAdd',
      name: 'contractAdd',
      component: _import('h5/contract/add'),
      meta: {
        'title': '新增合同',
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'contractAdd')
        next()
      },
    },

    {
      path: '/main',
      component: _import('h5/Main/index'),
      children: [
        {
          path: path('me'),
          name: 'mainMe',
          component: _import('h5/Main/me'),
          meta: {keepAlive: true, isBack: true, scrollToP: '0' },
          beforeEnter: (to, from, next) => {
            store.commit('changeMenu', 'mainMe')
            next()
          },
        },
        {
          path: path('home'),
          name: 'mainHome',
          component: _import('h5/Main/home'),
          meta: {keepAlive: true, isBack: true, scrollToP: '0' },
          beforeEnter: (to, from, next) => {
            store.commit('changeMenu', 'mainHome')
            next()
          },
        },
        {
          path: path('project'),
          name: 'mainProject',
          component: _import('h5/Main/project'),
          meta: {keepAlive: true, isBack: true, scrollToP: '0' },
          beforeEnter: (to, from, next) => {
            store.commit('changeMenu', 'mainProject')
            next()
          },
        },
        {
          path: path('worktop'),
          name: 'mainWorktop',
          component: _import('h5/Main/worktop'),
          meta: {keepAlive: true, isBack: true, scrollToP: '0' },
          beforeEnter: (to, from, next) => {
            store.commit('changeMenu', 'mainWorktop')
            next()
          },
        },
      ]
    },
    {
      path: '/userIndex',
      name: 'userIndex',
      component: _import('h5/user/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'userIndex')
        next()
      },
    },
    {
      path: '/userDetail',
      name: 'userDetail',
      component: _import('h5/user/detail'),
      meta: {
        'title': '资料详情'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'userDetail')
        next()
      },
    },
    {
      path: '/userAdd',
      name: 'userAdd',
      component: _import('h5/user/add'),
      meta: {
        'title': '添加员工'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'userAdd')
        next()
      },
    },
    {
      path: '/baoxiaoIndex',
      name: 'baoxiaoIndex',
      component: _import('h5/worktop/baoxiao/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'baoxiaoIndex')
        next()
      },
    },
    {
      path: '/baoxiaoDetail',
      name: 'baoxiaoDetail',
      component: _import('h5/worktop/baoxiao/detail'),
      meta: {
        'title': '报销审批详情'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'baoxiaoDetail')
        next()
      },
    },
    {
      path: '/baoxiaoAdd',
      name: 'baoxiaoAdd',
      component: _import('h5/worktop/baoxiao/add'),
      meta: {
        'title': '新增报销审批'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'baoxiaoAdd')
        next()
      },
    },
    {
      path: '/baoxiaoPayDetail',
      name: 'baoxiaoPayDetail',
      component: _import('h5/worktop/baoxiao/payDetail'),
      meta: {
        'title': '报销详情'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'baoxiaoPayDetail')
        next()
      },
    },
    {
      path: '/useSealIndex',
      name: 'useSealIndex',
      component: _import('h5/worktop/useSeal/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'useSealIndex')
        next()
      },
    },
    {
      path: '/useSealDetail',
      name: 'useSealDetail',
      component: _import('h5/worktop/useSeal/detail'),
      meta: {
        'title': '用印审批详情'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'useSealDetail')
        next()
      },
    },
    {
      path: '/useSealAdd',
      name: 'useSealAdd',
      component: _import('h5/worktop/useSeal/add'),
      meta: {
        'title': '新增用印审批'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'useSealAdd')
        next()
      },
    },{
      path: '/setProjectIndex',
      name: 'setProjectIndex',
      component: _import('h5/worktop/setProject/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'setProjectIndex')
        next()
      },
    },
    {
      path: '/setProjectDetail',
      name: 'setProjectDetail',
      component: _import('h5/worktop/setProject/detail'),
      meta: {
        'title': '立项审批详情'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'setProjectDetail')
        next()
      },
    },
    {
      path: '/setProjectAdd',
      name: 'setProjectAdd',
      component: _import('h5/worktop/setProject/add'),
      meta: {
        'title': '新增立项审批'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'setProjectAdd')
        next()
      },
    },
    {
      path: '/cgContractIndex',
      name: 'cgContractIndex',
      component: _import('h5/worktop/contract/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'cgContractIndex')
        next()
      },
    },
    {
      path: '/cgContractDetail',
      name: 'cgContractDetail',
      component: _import('h5/worktop/contract/detail'),
      meta: {
        'title': '采购合同审批详情'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'cgContractDetail')
        next()
      },
    },
    {
      path: '/cgContractAdd',
      name: 'cgContractAdd',
      component: _import('h5/worktop/contract/add'),
      meta: {
        'title': '新增采购合同审批'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'cgContractAdd')
        next()
      },
    },
    {
      path: '/invoiceIndex',
      name: 'invoiceIndex',
      component: _import('h5/worktop/invoice/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'invoiceIndex')
        next()
      },
    },
    {
      path: '/invoiceDetail',
      name: 'invoiceDetail',
      component: _import('h5/worktop/invoice/detail'),
      meta: {
        'title': '发票审批详情'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'invoiceDetail')
        next()
      },
    },
    {
      path: '/invoiceAdd',
      name: 'invoiceAdd',
      component: _import('h5/worktop/invoice/add'),
      meta: {
        'title': '新增发票审批'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'invoiceAdd')
        next()
      },
    },
    {
      path: '/paymentIndex',
      name: 'paymentIndex',
      component: _import('h5/worktop/payment/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'paymentIndex')
        next()
      },
    },
    {
      path: '/paymentDetail',
      name: 'paymentDetail',
      component: _import('h5/worktop/payment/detail'),
      meta: {
        'title': '付款审批详情'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'paymentDetail')
        next()
      },
    },
    {
      path: '/paymentAdd',
      name: 'paymentAdd',
      component: _import('h5/worktop/payment/add'),
      meta: {
        'title': '新增付款审批'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'paymentAdd')
        next()
      },
    },
    {
      path: '/paymentPayDetail',
      name: 'paymentPayDetail',
      component: _import('h5/worktop/payment/payDetail'),
      meta: {
        'title': '支付详情'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'paymentPayDetail')
        next()
      },
    },
    {
      path: '/paymentInvoiceDetail',
      name: 'paymentInvoiceDetail',
      component: _import('h5/worktop/payment/invoiceDetail'),
      meta: {
        'title': '发票管理'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'paymentInvoiceDetail')
        next()
      },
    },
    {
      path: '/shenpiList',
      name: 'shenpiList',
      component: _import('h5/shenpiList'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'shenpiList')
        next()
      },
    },
    {
      path: '/xzSpIndex',
      name: 'xzSpIndex',
      component: _import('h5/worktop/xzSp/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'xzSpIndex')
        next()
      },
    },
    {
      path: '/xzSpDetail',
      name: 'xzSpDetail',
      component: _import('h5/worktop/xzSp/detail'),
      meta: {
        'title': '行政审批详情'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'xzSpDetail')
        next()
      },
    },
    {
      path: '/xzSpAdd',
      name: 'xzSpAdd',
      component: _import('h5/worktop/xzSp/add'),
      meta: {
        'title': '新增行政审批'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'xzSpAdd')
        next()
      },
    },
    {
      path: '/projectDetail',
      name: 'projectDetail',
      component: _import('h5/project/detail'),
      meta: {
        'title': '项目详情'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'projectDetail')
        next()
      },
    },
    {
      path: '/projectAdd',
      name: 'projectAdd',
      component: _import('h5/project/add'),
      meta: {
        'title': '新建项目'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'projectAdd')
        next()
      },
    },
    {
      path: '/projectSpeed',
      name: 'projectSpeed',
      component: _import('h5/project/speed'),
      meta: {
        'title': '项目进度'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'projectSpeed')
        next()
      },
    },
    {
      path: '/wortReportIndex',
      name: 'wortReportIndex',
      component: _import('h5/wortReport/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'wortReportIndex')
        next()
      },
    },
    {
      path: '/wortReportDetail',
      name: 'wortReportDetail',
      component: _import('h5/wortReport/detail'),
      meta: {
        'title': '工作汇报详情'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'wortReportDetail')
        next()
      },
    },
    {
      path: '/wortReportAdd',
      name: 'wortReportAdd',
      component: _import('h5/wortReport/add'),
      meta: {
        'title': '写工作汇报'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'wortReportAdd')
        next()
      },
    },
    {
      path: '/clearingIndex',
      name: 'clearingIndex',
      component: _import('h5/clearing/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'clearingIndex')
        next()
      },
    },
    {
      path: '/clearingDetail',
      name: 'clearingDetail',
      component: _import('h5/clearing/detail'),
      meta: {
        'title': '结算详情'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'clearingDetail')
        next()
      },
    },
    {
      path: '/payCollectIndex',
      name: 'payCollectIndex',
      component: _import('h5/payCollection/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'payCollectIndex')
        next()
      },
    },
    {
      path: '/payCollectDetail',
      name: 'payCollectDetail',
      component: _import('h5/payCollection/detail'),
      meta: {
        'title': '回款详情'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'payCollectDetail')
        next()
      },
    },
    {
      path: '/checkAcceptIndex',
      name: 'checkAcceptIndex',
      component: _import('h5/checkAccept/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'checkAcceptIndex')
        next()
      },
    },
    {
      path: '/checkAcceptDetail',
      name: 'checkAcceptDetail',
      component: _import('h5/checkAccept/detail'),
      meta: {
        'title': '验收详情'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'checkAcceptDetail')
        next()
      },
    },
    {
      path: '/checkAcceptAdd',
      name: 'checkAcceptAdd',
      component: _import('h5/checkAccept/add'),
      meta: {
        'title': '新增验收'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'checkAcceptAdd')
        next()
      },
    },

    {
      path: '/clientIndex',
      name: 'clientIndex',
      component: _import('h5/client/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'clientIndex')
        next()
      },
    },
    {
      path: '/clientDetail',
      name: 'clientDetail',
      component: _import('h5/client/detail'),
      meta: {
        'title': '客户详情'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'clientDetail')
        next()
      },
    },
    {
      path: '/clientAdd',
      name: 'clientAdd',
      component: _import('h5/client/add'),
      meta: {
        'title': '新增验收'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'clientAdd')
        next()
      },
    },
    {
      path: '/clientPace',
      name: 'clientPace',
      component: _import('h5/client/pace'),
      meta: {
        'title': '项目进度'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'clientPace')
        next()
      },
    },
    {
      path: '/clientZong',
      name: 'clientZong',
      component: _import('h5/client/zong'),
      meta: {
        'title': '总包信息'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'clientZong')
        next()
      },
    },
    {
      path: '/clientJia',
      name: 'clientJia',
      component: _import('h5/client/jia'),
      meta: {
        'title': '甲方信息'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'clientJia')
        next()
      },
    },
    {
      path: '/supplyGoodsIndex',
      name: 'supplyGoodsIndex',
      component: _import('h5/supplyGoods/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'supplyGoodsIndex')
        next()
      },
    },
    {
      path: '/supplyGoodsDetail',
      name: 'supplyGoodsDetail',
      component: _import('h5/supplyGoods/detail'),
      meta: {
        'title': '供货详情'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'supplyGoodsDetail')
        next()
      },
    },
    {
      path: '/supplyGoodsAdd',
      name: 'supplyGoodsAdd',
      component: _import('h5/supplyGoods/add'),
      meta: {
        'title': '新增供货'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'supplyGoodsAdd')
        next()
      },
    },
    {
      path: '/cailiaoIndex',
      name: 'cailiaoIndex',
      component: _import('h5/cailiao/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'cailiaoIndex')
        next()
      },
    },
    {
      path: '/cailiaoDetail',
      name: 'cailiaoDetail',
      component: _import('h5/cailiao/detail'),
      meta: {
        'title': '材料库详情',
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'cailiaoDetail')
        next()
      },
    },
    {
      path: '/cailiaoAdd',
      name: 'cailiaoAdd',
      component: _import('h5/cailiao/add'),
      meta: {
        'title': '新增材料库',
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'cailiaoAdd')
        next()
      },
    },
    {
      path: '/knowledgeIndex',
      name: 'knowledgeIndex',
      component: _import('h5/knowledge/index'),
      meta: {keepAlive: true, isBack: true, scrollToP: '0' },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'knowledgeIndex')
        next()
      },
    },
    {
      path: '/knowledgeDetail',
      name: 'knowledgeDetail',
      component: _import('h5/knowledge/detail'),
      meta: {
        'title': '文章详情'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'knowledgeDetail')
        next()
      },
    },
    {
      path: '/userSet',
      name: 'userSet',
      component: _import('h5/userSet'),
      meta: {
        'title': '用户设置'
      },
      beforeEnter: (to, from, next) => {
        store.commit('changeMenu', 'userSet')
        next()
      },
    },
  ]
})

router.onError(error => {
  console.warn(error, error.message);
  let pattern = /Loading chunk(\d)+ failed/g;
  let isChunkLoadFailed = pattern.test(error.message);
  console.log(isChunkLoadFailed,'啊啊')
  let targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
  // router.replace(targetPath);
    location.reload();
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js